import { z } from 'zod';

export const MICROSOFT_SERVICES = ['onedrive', 'outlook', 'onenote'] as const;
export type MicrosoftService = (typeof MICROSOFT_SERVICES)[number];

const microsoftServiceSchema = z.enum(MICROSOFT_SERVICES);

const microsoftConnectBodySchema = z.object({
  accessToken: z.string(),
  extra: z.object({
    tenantId: z.string(),
  }),
  services: z.array(microsoftServiceSchema).optional(),
});

const microsoftConnectResponseSchema = z.object({
  connected: z.boolean(),
  services: z.array(microsoftServiceSchema),
});

export type MicrosoftConnectBody = z.infer<typeof microsoftConnectBodySchema>;
export type MicrosoftConnectResponse = z.infer<
  typeof microsoftConnectResponseSchema
>;

const integrationServiceSchema = z.object({
  type: z.union([microsoftServiceSchema, z.string()]),
  connected: z.boolean(),
});

const integrationStatusSchema = z.object({
  provider: z.string(),
  services: z.array(integrationServiceSchema),
});

const integrationsStatusResponseSchema = z.array(integrationStatusSchema);

export type IntegrationService = z.infer<typeof integrationServiceSchema>;
export type IntegrationStatus = z.infer<typeof integrationStatusSchema>;
export type IntegrationsStatusResponse = z.infer<
  typeof integrationsStatusResponseSchema
>;

const microsoftConnectedConvoSchema = z.object({
  id: z.string(),
  fileCount: z.number(),
});

const microsoftConnectedConvosResponseSchema = z.object({
  documentCount: z.number(),
  conversationCount: z.number(),
  conversations: z.array(microsoftConnectedConvoSchema),
});

export type MicrosoftConnectedConvo = z.infer<typeof microsoftConnectedConvoSchema>;
export type MicrosoftConnectedConvosResponse = z.infer<
  typeof microsoftConnectedConvosResponseSchema
>;

export const alfredIntegrations = {
  microsoftConnect: {
    path: 'alfred-integrations/v1/integrations/microsoft/connect',
    schema: microsoftConnectResponseSchema,
  },
  microsoftDisconnect: {
    path: 'alfred-integrations/v1/integrations/microsoft/disconnect',
  },
  integrationsStatus: {
    path: 'alfred-integrations/v1/integrations/status',
    schema: integrationsStatusResponseSchema,
  },
  microsoftConnectedConvos: {
    path: (service: MicrosoftService) =>
      `alfred-integrations/v1/integrations/microsoft/services/${service}/connected-convos`,
    schema: microsoftConnectedConvosResponseSchema,
  },
} as const;
